import { render, staticRenderFns } from "./home-members.vue?vue&type=template&id=bcbcaf36&scoped=true&"
import script from "./home-members.vue?vue&type=script&lang=js&"
export * from "./home-members.vue?vue&type=script&lang=js&"
import style0 from "./home-members.vue?vue&type=style&index=0&id=bcbcaf36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbcaf36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Touch from 'vuetify/lib/directives/touch'
installDirectives(component, {Touch})
